import { createSelector } from "reselect";
import get from "lodash/get";
import head from "lodash/head";
import { urlParam, isIOS } from "utils/helpers";
import { orderSelector, sadOrderSelector } from "../order";
import {
  guestOrderSelector,
  userOrdersDeliveryDetailsSelector
} from "../guestOrder";
import { getSessionToken } from "utils/localStorage";
import {
  outstandingBillsFormSelector,
  formValuesSelector
} from "ducks/selectors";
import { forms } from "utils/constants";
import { validateIccIdSelector } from "../validateIccId";

const manageOrderFormSelector = formValuesSelector(forms.MANAGE_ORDER_FORM);

const IosDeviceSelector = () => isIOS();

export const sessionTokenSelector = createSelector(
  manageOrderFormSelector,
  orderSelector,
  guestOrderSelector,
  sadOrderSelector,
  userOrdersDeliveryDetailsSelector,
  validateIccIdSelector,
  (formValues, order, guestOrder, sadOrder, userOrder, validateIccId) => {
    return (
      get(formValues, "sessionToken") ||
      get(guestOrder, "session_token") ||
      get(order, "session_token") ||
      get(sadOrder, "session_token") ||
      get(validateIccId, "session_token") ||
      urlParam("token") ||
      getSessionToken() ||
      get(head(userOrder), "session_token") ||
      ""
    );
  }
);

export const makeSelectManageOrderFormOTP = () =>
  createSelector(
    manageOrderFormSelector,
    outstandingBillsFormSelector,
    (manageFormValue, outstandingBillsformValues) => {
      return get(
        manageFormValue,
        "otp",
        get(outstandingBillsformValues, "otp")
      );
    }
  );

export const makeSelectManageOrderForm = () => manageOrderFormSelector;
export const makeSelectSessionToken = () => sessionTokenSelector;
export const makeSelectIosDevice = () => IosDeviceSelector;
